module.exports = __webpack_public_path__ + "static/media/account-d.462ecad8.svg";